module.exports = __webpack_public_path__ + "src/app/assets/images/abbott.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/images/abbott.png
// module id = 642
// module chunks = 0